import { ALL_CONTENT_FONTS } from '@gitbook/app-database';

import type { SiteOnlyCustomizationProps } from '../../types';
import { AbstractFontSettings } from './AbstractFontSettings';

/**
 * Settings to configure the font used in content.
 */
export function FontSettings(props: SiteOnlyCustomizationProps) {
    const { setSettings, settings } = props;
    return (
        <AbstractFontSettings
            {...props}
            defaultFonts={ALL_CONTENT_FONTS}
            font={settings.styling.font}
            setFont={(font) =>
                setSettings((prev) => ({
                    ...prev,
                    styling: { ...prev.styling, font },
                }))
            }
            label="Font"
        />
    );
}
